import styled from 'styled-components';

import { ReactPortalElementId } from 'core/layouts';
import { AnnouncementsContainer } from 'modules/announcements/components/Announcements.styled';

import { SDKSetupNotWorkingAnnouncement } from './SdkNotWorkingAnnouncement';

const AnonUserTrackingAnnouncementsContainer = styled(AnnouncementsContainer)`
  position: relative;
  bottom: 19px;
`;

export const AnonTrackingAnnouncements = () => {
  return (
    <AnonUserTrackingAnnouncementsContainer
      data-test={'announcements-anon-user-tracking'}
      id={ReactPortalElementId.announcementsAnonUserTracking}
    >
      <SDKSetupNotWorkingAnnouncement />
    </AnonUserTrackingAnnouncementsContainer>
  );
};
